import CmnBtnContainer from "./CmnBtnContainer";

const Footer = () => {
  return (
    <div id="footer">
      <div id="footer-content">
        <h1>Ready to get started?</h1>
        <h3>Try celaeno Timesheet for Free</h3>
        <p>No Credit Card Required</p>
          <div style={{margin : "auto"}}>
            <CmnBtnContainer/>
          </div>
      </div>
      <img src="/svg/footer-btm.svg" width="100%" alt="" />
    </div>
  )
}

export default Footer;